export default __webpack_public_path__ + "assets/models/4c5abad90211bd30703ffbacb4537a6f.glb";